import { Injectable, Pipe, PipeTransform } from '@angular/core'
import { CalculationModuleSignature } from '@core/models/calculation-module.model'

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'filterCMOnCategory',
})
export class filterCMOnCategoryPipe implements PipeTransform {
  transform(cms: CalculationModuleSignature[], category: string): CalculationModuleSignature[] {
    return cms.filter((cm) => {
      if (category === cm.category && cm.category != '') return cm
    })
  }
}
